module.exports = __webpack_public_path__ + "img/five03.f819f4b6.png";